import { AvatarVoiceTab, IAiAvatarState } from 'store/types/aiAvatar'
import {
  AVATAR_TTS_DEFAULT_SPEAKER_ID,
  TTS_DEFAULT_LANG_CODE,
  TTS_DEFAULT_SPEED
} from 'consts/tts'
import { AVATAR_DEFAULT_QUALITY } from './consts'

export const avatarVoiceInitial = {
  langCode: TTS_DEFAULT_LANG_CODE,
  speakerId: AVATAR_TTS_DEFAULT_SPEAKER_ID,
  speed: TTS_DEFAULT_SPEED
}

export const avatarGenerationInitialParams = {
  avatar: null,
  voice: avatarVoiceInitial,
  quality: AVATAR_DEFAULT_QUALITY,
  speechText: '',
  // null = follow the project aspect ratio until the user picks one.
  aspectRatio: null,
  targetMediaItemId: null
}

export const voiceCloneInitial = {
  activeTab: AvatarVoiceTab.LIBRARY,
  voice: null,
  uploadStatus: 'idle' as const
}

export const getInitialState = (): IAiAvatarState => ({
  isLoadingTabData: false,
  generationParams: avatarGenerationInitialParams,
  isAvatarLoading: false,
  voiceClone: voiceCloneInitial,
  generationClones: {},
  publicAvatars: {
    data: null,
    isLoading: false
  },
  avatarModels: {
    data: null,
    isLoading: false
  },
  giftAccess: {
    data: null,
    isLoading: false
  },
  isGenerating: false,
  isAwaitingGiftRecheck: false
})
